import { useQuery, useQueryClient, type UseQueryOptions } from 'react-query';

import type { IStageHistory } from 'src/services/api/lead-stage-history/types';
import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api';
import { GET_LEADS_PATH } from 'src/services/api/leads/constants';

export type IGetLeadStageHistoryResponse = {
    stages: IStageHistory[];
};

export const useLeadStageHistory = (
    leadUuid?: string,
    options?: UseQueryOptions<IStageHistory[], unknown>
) => {
    const queryClient = useQueryClient();

    return useQuery<IStageHistory[]>(
        [queryKeys.leadStageHistory, leadUuid],
        async () => {
            if (!leadUuid) {
                // if called with no uuid, don't make the request
                return [];
            }
            const res = await apiClient(`${GET_LEADS_PATH}/${leadUuid}/stages/history`).json<IGetLeadStageHistoryResponse>();
            return res.stages;
        },
        {
            enabled: !!leadUuid,
            onSuccess: (data) => {
                queryClient.setQueryData([queryKeys.leadStageHistory, leadUuid], data);
            },
            ...options,
        }
    );
};